import { OrderItemDetailEntity } from '../entity/order/order-item-detail.entity';

export class OrderItemDetailView {
  orderItemDetail?: OrderItemDetailEntity;
  orderItemTypeName?: string;
  preparedDate?: Date;
  preparedUser?: number;
  isAvailableForDispatch?: boolean;
  dispatchStatusId?: number;
  dispatchDate?: Date;
  supplierId?: number;
}
